import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import type { OverlayBannerSubBlock } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { richT } from "@thelabnyc/thelabui/src/utils/richText";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

export const OverlayBannerBlock = (
    props: Immutable<{ value: OverlayBannerSubBlock }>,
): React.JSX.Element | null => {
    const v = props.value;
    if (!v.theme) {
        return null;
    }
    return (
        <section
            className={concatClassNames([
                "overlay-banner",
                v.theme,
                v.color ?? "",
                v.responsive_visibility?.visibility ?? "",
                v.content_alignment ?? "",
            ])}
        >
            {v.theme === "overlay-banner--promotional" && (
                <>
                    <RichTextBlock value={v.header ?? ""} />
                    <div aria-hidden="true" className="divider"></div>
                    <div className="content">
                        {richT(
                            t`<row>SAVE <span>UP TO</span></row><row>${v.content}</row><row>on adjustable mattress sets<sup>¶</sup></row>`,
                            {
                                row: (children) => <div>{children}</div>,
                                span: (children) => <span>{children}</span>,
                            },
                        )}
                    </div>
                </>
            )}
            {v.theme === "overlay-banner--evergreen" && (
                <>
                    <div className="evergreen-title">
                        <h4>
                            {richT(
                                t`$300 INSTANT GIFT<br /><span>with your mattress set purchase</span>`,
                                {
                                    span: (children) => <span>{children}</span>,
                                },
                            )}
                        </h4>
                    </div>
                    {v.content && (
                        <>
                            <div aria-hidden="true" className="divider"></div>
                            <div className="content">
                                {richT(
                                    t`<row>USE CODE</row><row>${v.content}</row>`,
                                    {
                                        row: (children) => (
                                            <div>{children}</div>
                                        ),
                                    },
                                )}
                            </div>
                        </>
                    )}
                </>
            )}
            {v.theme === "overlay-banner--limited-time" && (
                <>
                    <RichTextBlock value={v.header ?? ""} />
                    <div aria-hidden="true" className="divider"></div>
                    <div className="content">
                        {richT(t`LIMITED-TIME<br />OFFER`)}
                    </div>
                </>
            )}
            {(v.theme === "overlay-banner--transparent-text-block" ||
                v.theme === "overlay-banner--diagonal") && (
                <RichTextBlock value={v.header ?? ""} />
            )}
            {v.page && (
                <>
                    <div aria-hidden="true" className="divider"></div>
                    <a className="call-to-action" href={v.page.url}>
                        {v.call_to_action}
                        <span className="triangle" aria-hidden="true"></span>
                    </a>
                </>
            )}
        </section>
    );
};
